/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_2_AInputs */

const en_mk_how_2_a = /** @type {(inputs: Mk_How_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features become sub-features and phased tasks, each with pass/fail criteria`)
};

const id_mk_how_2_a = /** @type {(inputs: Mk_How_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur jadi sub-fitur dan task berfase, masing-masing dengan kriteria lulus/gagal`)
};

/**
* | output |
* | --- |
* | "Features become sub-features and phased tasks, each with pass/fail criteria" |
*
* @param {Mk_How_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_2_a = /** @type {((inputs?: Mk_How_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_2_a(inputs)
	return en_mk_how_2_a(inputs)
});